import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  closePullRequestMutation,
  closePullRequestMutation$data,
} from './__generated__/closePullRequestMutation.graphql'

export function closePullRequestMutation({
  environment,
  input: {pullRequestId},
  onError,
  onCompleted,
}: {
  environment: Environment
  input: {pullRequestId: string}
  onError?: (error: Error) => void
  onCompleted?: (response: closePullRequestMutation$data) => void
}) {
  return commitMutation<closePullRequestMutation>(environment, {
    mutation: graphql`
      mutation closePullRequestMutation($pullRequestId: ID!) @raw_response_type {
        closePullRequest(input: {pullRequestId: $pullRequestId}) {
          pullRequest {
            id
            state
            viewerCanReopen
          }
        }
      }
    `,
    variables: {pullRequestId},
    optimisticResponse: {
      closePullRequest: {
        pullRequest: {
          id: pullRequestId,
          state: 'CLOSED',
          // Not assuming that the pull request can be reopened on optimistic response
          // This will be updated on actual response
          viewerCanReopen: false,
        },
      },
    },
    onError: error => onError?.(error),
    onCompleted: response => onCompleted?.(response),
  })
}
